<script>
/**
 * ****************************************************************************
 * @description     :   EmptyLayout
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import template
 */
import template from './template.html';
import { mapState } from 'vuex';

/**
 * import component
 */
import HeaderError from '@/components/headerError';
import Loading from '@/components/loading';
import MainHeader from '@/shared/header';
import MainFooter from '@/shared/footer';
import ModalMessage from '@/shared/modal-message/index.vue';
/**
 * Define main layout
 */
export default {
    name: 'EmptyLayout',
    template: template,
    props: {
        showHeader: {
            type: Boolean,
            default: true
        }
    },
    components: {
        ModalMessage,
        HeaderError,
        Loading,
        MainHeader,
        MainFooter
    },
    mounted() {
        window.addEventListener('keydown', (e) => {
            //f9 save
            if (e.keyCode == 120) {
                e.preventDefault();
                document.getElementById('button-register')?.click();
            }
            //f12 back
            if (e.keyCode == 123) {
                e.preventDefault();
                document.getElementById('button-back')?.click();
                return false;
            }
        });
    },
    computed: {
        ...mapState('app', ['isFaqLayout']),
        isShowHeader() {
            return this.showHeader && this.$route.name !== 'PreviewPdf';
        }
    }
};
</script>

<style lang="scss">
.ptj-container-login {
    background: #3e99da !important;
}
</style>
